import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import styles from './LoginPage.module.css'; // Assuming you have some styles defined

const STORAGE_KEY = 'login:remembered-username';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [rememberAccount, setRememberAccount] = useState(true);
    const { login, user } = useAuth();
    const navigate = useNavigate();
    const title = import.meta.env.VITE_APP_TITLE || '自動化監測整合視覺平台';
    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate]);

    useEffect(() => {
        const savedUsername = localStorage.getItem(STORAGE_KEY);
        if (savedUsername) {
            setUsername(savedUsername);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Clear previous errors
        try {
            const result = await login(username, password);
            if (result?.requiresPasswordReset) {
                navigate('/first-login/reset', { state: { token: result?.token } });
                return;
            }
            if (result?.success) {
                if (rememberAccount) {
                    localStorage.setItem(STORAGE_KEY, username);
                } else {
                    localStorage.removeItem(STORAGE_KEY);
                }
                navigate('/');
            } else {
                setError(result?.error || 'Invalid username or password');
            }
        } catch (error) {
            setError('Login failed. Please try again.');
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h1 style={{ textAlign: 'center' }}>{title}</h1>
                <h2>登入 SIGN IN</h2>
                <form onSubmit={handleSubmit}>
                    {
                        <p style={{ color: 'red', minHeight: '25px', margin: 0 }}>
                            {error}
                        </p>
                    }
                    <div className={styles.formGroup}>
                        <label>帳號</label>
                        <input
                            placeholder="Email"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className={styles.formGroup}>
                        <label>密碼</label>
                        <input
                            value={password}
                            type="password"
                            placeholder="Password"
                            autoComplete="on"
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className={styles.rememberRow}>
                        <label className={styles.rememberLabel}>
                            <input
                                type="checkbox"
                                checked={rememberAccount}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    setRememberAccount(checked);
                                    if (!checked) {
                                        localStorage.removeItem(STORAGE_KEY);
                                    }
                                }}
                            />
                            記住帳號
                        </label>
                    </div>
                    <button className={styles.formButton} type="submit">
                        SIGN IN
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
